exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TeamStats__awayTeamName--2ESDc,\n.TeamStats__homeTeamName--Iaaqt {\n  color: #f9f9f9;\n  opacity: 0.65;\n  font-weight: 400;\n}\n\n.TeamStats__awayTeamName--2ESDc {\n  display: inline-block;\n  text-align: left;\n  width: 50%;\n}\n\n.TeamStats__homeTeamName--Iaaqt {\n  display: inline-block;\n  text-align: right;\n  width: 50%;\n}\n\n.TeamStats__noData--2e9oe {\n  font-weight: 400;\n  padding: 10px;\n}", ""]);

// exports
exports.locals = {
	"awayTeamName": "TeamStats__awayTeamName--2ESDc",
	"homeTeamName": "TeamStats__homeTeamName--Iaaqt",
	"noData": "TeamStats__noData--2e9oe"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };